module.exports = __webpack_public_path__ + "img/x-twitter.64b6e7ad.png";